"use client";
import { FACET_FETCH_LIMIT } from "@/components/Search/constants";
import { PRODUCT_SUMMARY_INDEX_EN } from "@/constants/algolia";
import { buildFacetFiltersFromQuiz } from "./buildFacetFiltersFromQuiz";
import { QuizConfig } from "@/components/GuidedPath/type";
import clientSearch from "@/lib/algolia/clientSearch";
import getFilters from "@/components/Search/utils/getFilters";

export interface FetchFacetsParams {
  filterCategory: string;
  currentAnswers: Record<string, string | string[]>;
  searchableKeys: Set<string>;
  additionalFacets?: string[];
  quizConfig: QuizConfig;
}

export interface FetchFacetsResult {
  facets: Record<string, number>;
  allFacets: Record<string, Record<string, number>>;
}

export const getActiveProductSummaryFacetsFromAnswers = async ({
  filterCategory,
  currentAnswers,
  searchableKeys,
  additionalFacets = [],
  quizConfig,
}: FetchFacetsParams): Promise<FetchFacetsResult> => {
  // Use buildFacetFilters to handle facetMappings correctly
  const facetFilters = buildFacetFiltersFromQuiz(
    currentAnswers,
    searchableKeys,
    quizConfig,
    filterCategory, // Exclude current category from filters
  );

  const facetsToFetch = new Set<string>([filterCategory, ...additionalFacets]);

  const response = await clientSearch([
    {
      indexName: PRODUCT_SUMMARY_INDEX_EN,
      params: {
        facets: Array.from(facetsToFetch),
        facetFilters,
        hitsPerPage: 0,
        maxValuesPerFacet: FACET_FETCH_LIMIT,
      },
    },
  ]);

  const facets = response.results?.[0]?.facets?.[filterCategory] ?? {};
  const allFacets = response.results?.[0]?.facets ?? {};

  return { facets, allFacets };
};
